// External dependencies
import React, { useState, useEffect } from 'react';

// Internal dependencies
import AdminLayout from './AdminLayout.component.js';
import DashboardChart from './DashboardChart.component.js';
import DashboardStats from './DashboardStats.component.js';
import LoadingIndicator from '@/modules/core/client/components/LoadingIndicator';
import { getDashboardStats } from '../api/admin-dashboard.api';

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function fetchStats() {
      try {
        const data = await getDashboardStats();
        setStats(data);
      } catch (error) {
        /* eslint-disable no-console */
        console.log(error);
        // Set default stats if API fails
        setStats({
          totalUsers: 0,
          activeUsers: 0,
          totalMessages: 0,
          totalThreads: 0,
          userGrowth: [],
          messageActivity: [],
          userDistribution: [],
        });
      } finally {
        setIsLoading(false);
      }
    }
    fetchStats();
  }, []);

  return (
    <AdminLayout>
      <div className="admin-dashboard">
        <div className="admin-dashboard__header">
          <h1>Admin Dashboard</h1>
          <p className="admin-dashboard__subtitle">
            Welcome to the admin panel! 👋
          </p>
        </div>

        {isLoading ? (
          <LoadingIndicator />
        ) : (
          <>
            <DashboardStats stats={stats} />
            <div className="admin-dashboard__charts">
              <div className="admin-dashboard__chart-row">
                <div className="admin-dashboard__chart-card">
                  <h3>User Growth & Activity</h3>
                  <DashboardChart
                    type="composed"
                    data={stats?.userGrowth || []}
                    label="Users"
                    color="#4CAF50"
                  />
                </div>
                <div className="admin-dashboard__chart-card">
                  <h3>User Distribution</h3>
                  <DashboardChart
                    type="radial"
                    data={stats?.userDistribution || []}
                    label="Users"
                  />
                </div>
              </div>
              <div className="admin-dashboard__chart-row">
                <div className="admin-dashboard__chart-card">
                  <h3>Message Activity</h3>
                  <DashboardChart
                    type="composed"
                    data={stats?.messageActivity || []}
                    label="Messages"
                    color="#2196F3"
                  />
                </div>
                <div className="admin-dashboard__chart-card">
                  <h3>Quick Links</h3>
                  <div className="admin-dashboard__quick-links">
                    <a
                      href="https://team.trustroots.org/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="admin-dashboard__quick-link"
                    >
                      Team Guide
                    </a>
                    <a
                      href="https://trustroots.zendesk.com/inbox/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="admin-dashboard__quick-link"
                    >
                      Support queue
                    </a>
                    <a
                      href="/admin/cms/posts"
                      className="admin-dashboard__quick-link"
                    >
                      Blog admin
                    </a>
                    <a
                      href="https://ideas.trustroots.org/wp-admin/admin.php?page=mailpoet-newsletters"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="admin-dashboard__quick-link"
                    >
                      Newsletter admin
                    </a>
                    <a
                      href="https://grafana.trustroots.org/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="admin-dashboard__quick-link"
                    >
                      Statistics
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="admin-dashboard__footer">
              <p>
                <strong>
                  <em>Remember to logout on public computers!</em>
                </strong>
              </p>
            </div>
          </>
        )}
      </div>
    </AdminLayout>
  );
}

AdminDashboard.propTypes = {};
